module.exports = __webpack_public_path__ + "static/media/foundingYear.559fd338.svg";